import { FormProvider, useForm, useFormContext } from "react-hook-form";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";
import { CDropPropertyKeys, DropPropertySchema } from "../util/propertyDropSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { IDropPropertySchema } from "../util/propertyDropSchema";
import { CDropProperty } from "../util/propertyDropSchema";
import { Grid } from "@mui/material";

import MxFormL3RadioField from "@rf-l3/form/MxFormL3RadioField";
import { useMemo } from "react";
import MxFormSubTitleAndDescription from "@rf-l1/page/form/MxFormSubTitleAndDescription";
import MxFormL3TextAreaField from "@rf-l3/form/MxFormL3TextAreaField";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import ENVIRONMENT_VAR from "@/shared/models/environment/environments.var";
import useModal from "@rf/base/modal/useModal";
import useUserHelp from "@rf-hooks/useUserHelp";
import { useDropPropertyMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import toast from "react-hot-toast";
import HCheckArray from "@rf-helper/check-have-value";
import HTransformObject from "@rf-helper/transform-object.helper";
import { HCatchServerError } from "@rf-helper/cath-error-server";
export interface IDropPropertyTemplateModalData {
  propertyId: string;
  variant: "property" | "unit" | "project";
}
export const DropPropertyTemplateModal = () => {
  const { USER_ROLE } = useUserHelp();
  const { getData, onConfirm, onClose } = useModal();
  const { propertyId, variant } = getData() as IDropPropertyTemplateModalData;
  console.log(propertyId, variant);
  const [dropProperty, { isLoading }] = useDropPropertyMutation();

  const form = useForm<IDropPropertySchema>({
    resolver: yupResolver(DropPropertySchema),
    defaultValues: CDropProperty
  });

  const onSubmit = (data: IDropPropertySchema) => {
    const body = HTransformObject(
      {
        other_reason: data.otherReason,
        business_days: HCheckArray(data.businessDays)
          ? +data.businessDays[0].value
          : undefined,
        reason: data.reason
      },
      {
        removeUndefined: true,
        removeEmptyArray: true,
        removeNull: true,
        removeEmptyStrings: true,
        removeEmptyObjects: true
      }
    );
    const response = dropProperty({
      params: {
        id: propertyId
      },
      body
    }).unwrap();

    toast
      .promise(response, {
        loading: "La propiedad se está dando de baja...",
        success: "La propiedad se ha dado de baja correctamente",
        error: e => HCatchServerError(e)
      })
      .then(() => {
        onConfirm();
      })
      .catch(e => {
        onClose();
      });
  };

  const { property, unit, project } = useMemo(() => {
    return {
      property: variant === "property",
      unit: variant === "unit",
      project: variant === "project"
    };
  }, [variant]);

  const reasons = useMemo(() => {
    return [
      {
        ...reazons.property_sold,
        show: property || unit
      },
      {
        ...reazons.owner_not_interested,
        show: property || unit || project
      },
      {
        ...reazons.owner_sold_property,
        show: property || unit || project
      },
      {
        ...reazons.property_in_negotiation,
        show: property || unit || project
      },
      {
        ...reazons.other_reason,
        show: property || unit || project
      },
      {
        ...reazons.red_alert,
        show: (property || unit || project) && USER_ROLE.SUPER_ADMIN
      }
    ].filter(reason => reason.show);
  }, [property, unit, project]);

  return (
    <MxModalTemplate2>
      <Grid container rowGap={2}>
        <Grid item xs={12}>
          <MxFormSubTitleAndDescription
            label="Selecciona la razón por la cual desea dar de baja a esta propiedad:"
            description="Esta propiedad será enviada al agente que la creó junto con la razón que
            se seleccione."
          />
        </Grid>

        <Grid item xs={12}>
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <Grid container rowGap={2}>
                <Grid item xs={12}>
                  <MxFormL3RadioField
                    withreacthookform={1}
                    name={CDropPropertyKeys.reason}
                    label=""
                    items={reasons}
                    direction="column"
                  />
                </Grid>
                <OtherReason />
                <ButtonsFooter />
              </Grid>
            </form>
          </FormProvider>
        </Grid>
      </Grid>
    </MxModalTemplate2>
  );
};

const OtherReason = () => {
  const { watch } = useFormContext();
  const reason = watch(CDropPropertyKeys.reason);
  if (reason == "1" || reason == "2" || reason == "3" || reason == "") return null;

  if (reason == "4")
    return (
      <Grid item xs={12}>
        <MxFormL3AutoComplete
          withreacthookform={1}
          name={CDropPropertyKeys.businessDays}
          label="Seleccionar días que estará de baja"
          items={A_DAYS_TO_UNSUBSCRIBE}
        />
      </Grid>
    );

  if (reason == "6" || reason == "5") {
    return (
      <Grid item xs={12}>
        <MxFormL3TextAreaField
          withreacthookform={1}
          name={CDropPropertyKeys.otherReason}
          label={
            reason == "6"
              ? "Agrega un comentario a este conflicto"
              : "Agrega un comentario"
          }
          rows={3}
        />
      </Grid>
    );
  }
  return null;
};

const ButtonsFooter = () => {
  const { watch, getValues } = useFormContext();
  const { getData, onClose } = useModal();
  const { propertyId } = getData() as IDropPropertyTemplateModalData;
  const reason = watch(CDropPropertyKeys.reason);
  const otherReason = watch(CDropPropertyKeys.otherReason);
  const disabledButton = useMemo(() => {
    if (reason == "1") return true;
    if (reason == "6") return false;

    return false;
  }, [reason, otherReason]);

  const handleReportCommission = () => {
    window.location.href =
      ENVIRONMENT_VAR.MAXCORE_DOMAIN_V1 + `/commissions/create?id=${propertyId}`;
  };
  return (
    <Grid container item xs={12}>
      {reason == "1" && (
        <Grid item xs="auto">
          <MxButton2
            variant="contained"
            color="success"
            onClick={handleReportCommission}
          >
            Reportar comisión
          </MxButton2>
        </Grid>
      )}
      <Grid item flex={1} />
      <Grid container item xs="auto" gap={2}>
        <Grid item xs="auto">
          <MxButton2
            variant="contained"
            color="error"
            onClick={() => {
              onClose();
            }}
          >
            Cancelar
          </MxButton2>
        </Grid>
        <Grid item xs="auto">
          <MxButton2
            disabled={disabledButton}
            variant="contained"
            color="primary"
            type="submit"
          >
            Dar de baja
          </MxButton2>
        </Grid>
      </Grid>
    </Grid>
  );
};

const reazons = {
  property_sold: {
    label: "La propiedad se vendió/alquiló",
    value: "1",
    name: "reason",
    id: "reason-1",
    show: true
  },
  owner_not_interested: {
    label: "El propietario ya no está interesado en vender o alquilar la propiedad",
    value: "2",
    name: "reason",
    id: "reason-2",
    show: true
  },
  owner_sold_property: {
    label: "El propietario vendió o alquiló la propiedad por medio de otro agente",
    value: "3",
    name: "reason",
    id: "reason-3",
    show: true
  },
  property_in_negotiation: {
    label: "Propiedad está en negociación",
    value: "4",
    name: "reason",
    id: "reason-4",
    show: true
  },
  other_reason: {
    label: "Otra razón",
    value: "5",
    name: "reason",
    id: "reason-5",
    show: true
  },
  red_alert: {
    label: "Alerta roja",
    value: "6",
    name: "reason",
    id: "reason-6",
    show: true
  }
};

export const A_DAYS_TO_UNSUBSCRIBE: any[] = [
  {
    label: "10",
    value: "10",
    name: "business_days"
  },
  {
    label: "15",
    value: "15",
    name: "business_days"
  },
  {
    label: "20",
    value: "20",
    name: "business_days"
  },
  {
    label: "25",
    value: "25",
    name: "business_days"
  },
  {
    label: "30",
    value: "30",
    name: "business_days"
  },
  {
    label: "60",
    value: "60",
    name: "business_days"
  }
];
